import React, { useContext } from 'react';
import { Alert, Button, ThemeProvider, useMediaQuery } from '@mui/material';
import { Context } from '../../../context/UserContext';
import tableThemeCustom from '../../form/tableThemeCustom';
import styles from '../../form/Form.module.css';
import Form from './Form';
import { usePermissoesModule } from './modules/usePermissoesModule';
import { useEleicaoModule } from './modules/useEleicaoModule';
import { useDocumentosModule } from './modules/useDocumentosModule';
import { useChapasModule } from './modules/useChapasModule';
import { useResultadoModule } from './modules/useResultadoModule';
import { useComissaoModule } from './modules/useComissaoModule';

export default function CreateOrEdit() {
    const { parametro } = useContext(Context);
    const theme = tableThemeCustom();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const permissoes = usePermissoesModule();
    const cadastro = useEleicaoModule(permissoes);
    const comissao = useComissaoModule({
        dados: cadastro.dados,
        setDados: cadastro.setDados,
        dadosSalvos: cadastro.dadosSalvos,
        permissoes,
        bloqueado: !cadastro.podeSalvar || cadastro.isSubmitting || cadastro.carregando,
    });
    const chapas = useChapasModule({
        eleicao: cadastro.dadosSalvos,
        permissoes,
        bloqueado: cadastro.isSubmitting || cadastro.carregando,
    });
    const documentos = useDocumentosModule({
        eleicao: cadastro.dadosSalvos,
        permissoes,
        bloqueado: cadastro.isSubmitting || cadastro.carregando || chapas.ocupado,
    });
    const resultado = useResultadoModule({
        eleicao: cadastro.dadosSalvos,
        permissoes,
        bloqueado: cadastro.isSubmitting || cadastro.carregando || documentos.ocupado || chapas.ocupado,
        chaveChapas: chapas.lista,
    });
    if (!permissoes.autorizado) return <Alert severity={permissoes.pronto ? 'warning' : 'info'}>{permissoes.mensagem}</Alert>;
    if (cadastro.carregando) return <Alert severity="info">Carregando eleição...</Alert>;
    if (cadastro.erro)
        return (
            <>
                <Alert severity="error">{cadastro.erro}</Alert>
                <Button onClick={cadastro.voltar}>Voltar</Button>
            </>
        );
    return (
        <ThemeProvider theme={theme}>
            <section className={`${styles.form_container} ${styles[parametro?.tema] || ''}`}>
                <Form
                    resultado={resultado}
                    chapas={chapas}
                    documentos={documentos}
                    permissoes={permissoes}
                    cadastro={cadastro}
                    comissao={comissao}
                    parametro={parametro}
                    isMobile={isMobile}
                />
            </section>
        </ThemeProvider>
    );
}
